import { Text, VStack } from '@chakra-ui/react'
import { routes } from '../../routes'
import { Link } from 'react-router-dom'

export const ExceedSeatLimitNotificationContent = () => {
  return (
    <VStack alignItems={'stretch'}>
      <Text>Your subscriptions don't have enough seats for all the prescribers.</Text>
      <Text paddingBottom={8}>
        To start sending prescriptions again, please contact your organisation administrator. Click{' '}
        <Link to={`${routes.settings.path}?tab=users`} style={{ color: 'dodgerblue' }}>
          here
        </Link>{' '}
        to check organisation users.
      </Text>
    </VStack>
  )
}
